/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import React from 'react';
import { Container, Grid, Box, Hidden, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';
import masterCardImg from '@/assets/images/masterCard.png';
import visaImg from '@/assets/images/visa.png';
import ZskImg from '@/assets/images/zsk.png';
import ZfbImg from '@/assets/images/zhifubao.png';

const FlexBox = styled(Box)({
  padding: '4px',
  borderRadius: '5px',
  marginRight: '20px',
  width: '89.95px',
  height: '41.61px',
});

const MainFooter = () => {
  const { info } = useSelector((state) => state.main);
  const { payment_list } = info;

  const { t } = useTranslation('main');
  const curYear = new Date().getFullYear();

  return (
    <Box
      sx={{
        height: 'auto',
        backgroundColor: '#375A7F',
        '@media print': {
          display: 'none',
        },
        padding: '10px 0',
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          height: 'auto',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            md={8}
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            {info.school_copyright ? (
              <div style={{ marginLeft: '20px' }}>
                {process.env.REACT_APP_SCHOOL_CODE === 'victoria' && (
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    component="p"
                    sx={{ margin: '0px', fontSize: '12px' }}
                  >
                    © {curYear} {t('veo_copyRight')}
                  </Typography>
                )}
                {process.env.REACT_APP_SCHOOL_CODE !== 'victoria' && (
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    component="p"
                    sx={{ margin: '0px', fontSize: '12px' }}
                  >
                    © {curYear} by {info.school_copyright} Developed by EVI
                    Services Limited
                  </Typography>
                )}
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  component="p"
                  sx={{ margin: '0px', fontSize: '12px' }}
                >
                  Version {process.env.REACT_APP_VERSION} &nbsp;&nbsp;
                  {process.env.REACT_APP_SCHOOL_CODE !== 'victoria' &&
                    ` ${t('support_phone')}
                    2114 0333`}
                </Typography>
              </div>
            ) : (
              <Box sx={{ width: 300 }}>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
              </Box>
            )}
          </Grid>
          {payment_list !== false && (
            <Hidden mdDown>
              <Grid item md={4} sx={{ display: 'flex', alignItems: 'center' }}>
                {payment_list ? (
                  payment_list?.map((item) => (
                    <FlexBox key={item.id} sx={{ background: '#fff' }}>
                      <img
                        style={{
                          objectFit: 'contain',
                          width: '100%',
                          height: '100%',
                        }}
                        src={item.logo}
                        alt={item.psp_name}
                      />
                    </FlexBox>
                  ))
                ) : (
                  <Box>
                    <Skeleton variant="rounded" width={300} height={41.61} />
                  </Box>
                )}
              </Grid>
            </Hidden>
          )}
        </Grid>
      </Container>
    </Box>
  );
};
export default MainFooter;
